import { PrimaryButton } from '@micro-frontend-react/employee-experience/lib/Buttons/PrimaryButton';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { getPageLoadFeature } from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import { usePageTracking } from '@micro-frontend-react/employee-experience/lib/usePageTracking';
import { useUser } from '@micro-frontend-react/employee-experience/lib/useUser';
import * as React from 'react';
import { useWindowDimensions } from '../Shared/Hooks/useWindowDimensions';
import * as Styled from './NotAllowed.styled';
import { ButtonLink } from './NotAllowed.styled';

export function NotAllowed(): React.ReactElement {
  const handleAskHRButtonClicked = (): void => {
    window.open('mailto:askhr@microsoft.com');
  };

  const user = useUser();
  const { authClient } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);

  let descriptionText =
    'You have successfully authenticated; however, we could not find an employee record that matches your ';
  if (user && user?.email) {
    descriptionText += user?.email;
  }

  descriptionText += ' personal email address.';

  const { height } = useWindowDimensions();
  usePageTracking(
    getPageLoadFeature({
      feature: 'Offboarding',
      subFeature: 'NotAllowed',
    })
  );

  return (
    <Styled.Wrapper height={height} data-testid="not-allowed-page">
      <Styled.Root height={height}>
        <Styled.Image />
        <Styled.Heading>Record not found</Styled.Heading>
        <Styled.Description>{descriptionText}</Styled.Description>
        <Styled.GuestMode>
          Please try a different&nbsp;
          <ButtonLink
            title="Log out"
            onClick={() => {
              authClient.logOut();
            }}
            usageEvent={{
              feature: 'Offboarding',
              subFeature: 'NotAllowed.LogOutLink',
              subFeatureLevel2: '',
              featureLocation: '',
            }}
          >
            login
          </ButtonLink>
          account or you may view limited content by continuing as guest
        </Styled.GuestMode>
        <PrimaryButton
          text="Contact AskHR for help"
          onClick={handleAskHRButtonClicked}
          title="Contact AskHR for help"
          usageEvent={{
            feature: 'Offboarding',
            subFeature: 'NotAllowed.ContactAskHRButton',
          }}
        />
      </Styled.Root>
    </Styled.Wrapper>
  );
}
